import { Button } from '@mui/material';
import { chatStyles } from '@zonofi/chats-common/styles';
import { useGetMessageData } from '@zonofi/chats-common/hooks/get-message-data';
import { TemplateComponents } from '@zonofi/chats-web/message-template/template-components';
import { MessageEnvelope } from '@zonofi/common/schema/message/inferface';
import { MessageType } from '@zonofi/common/schema/message/enum';
import { TemplateButtonTypeEnum } from '@zonofi/common/schema/message/enum';
import { theme } from '@zonofi/common/theme/theme';
import { useRenderTemplateUi } from '@zonofi/common/hooks/render-template-ui';
import { getEmojiFromUnicode } from '@zonofi/chats-common/functions/emoji-handler';

import React, { useEffect, useState } from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import './whatsapp-chat-item.scss';
// import { MenuItem } from '../../../../common/interface';
import {
  dispatch,
  finService,
  getIsTourActive,
  TrackEventType,
  updateActiveTourTooltipIndex,
  useAppSelector,
} from '@zonofi/seller-rtk-store';
import { JTBD_SVGS } from '../../../../assets';
import { SIGNUP_ONBOARDING } from '@zonofi/gandalf-utilities';
import { useNavigate } from 'react-router-dom';
import { ReplyView } from '@zonofi/chats-web/message-template/reply-view';
import { MessageLabel } from '@zonofi/chats-web/message-template/message-label';

interface WhatsappChatItemProps {
  changeToZonoMoneySimulator?: (url: string) => void;
  envelope: MessageEnvelope;
  key: string;
  onMenuClick: (val: any[], msgId: string) => void;
  publishQuickReply: (contextId: string, text: string) => void;
  publishReaction: (contextId: string, text: string, replyText: string) => void;
  scrollToItem: (key: string) => void;
  sendSampleQuestion: (val: string) => void;
}

export const WhatsappChatItem: React.FC<WhatsappChatItemProps> = ({
  changeToZonoMoneySimulator,
  envelope,
  key,
  onMenuClick,
  publishQuickReply,
  publishReaction,
  scrollToItem,
  sendSampleQuestion,
}) => {
  const {
    variant,
    msgTime,
    buttons,
    template,
    isForwarded,
    repliedForMessage,
    userName,
    label,
    msgId,
    bannerData,
    repliedForMessageData,
    msgType,
    deleted,
    reactions,
    intent,
    reply,
    timetoken,
  } = useGetMessageData(envelope);

  console.log(timetoken, envelope);

  const renderedComponents = useRenderTemplateUi({
    messageId: msgId,
    template,
    bannerData,
    templateUI: TemplateComponents(variant),
  });
  const navigate = useNavigate();
  const isTourActive = useAppSelector(getIsTourActive);
  const feedback = getEmojiFromUnicode(reactions?.[0]?.emoji);

  const [showFeedbackButtons, setShowFeedbackButtons] =
    useState<boolean>(false);

  useEffect(() => {
    if (intent) {
      setShowFeedbackButtons(intent === 'unknown' || intent?.endsWith('agent'));
    }
  }, [intent]);

  if (deleted || msgType === MessageType.CHANNEL_UPDATE) return null;

  return (
    <div
      className={`whatsapp-chat-item ${
        variant === 'sender' ? 'flexColumnAlStart sender' : 'flexColumnAlEnd'
      } primary-font-regular`}
      data-key={msgId}
      style={
        variant === 'sender' && showFeedbackButtons
          ? { paddingBottom: '30px' }
          : {}
      }
    >
      <div
        className={`message-template tertiary-font-regular whatsapp-chat-item-body ${
          variant === 'sender' ? 'sender-chat-item' : 'receiver-chat-item'
        }`}
        style={variant !== 'sender' ? { paddingTop: '2px' } : {}}
      >
        {isForwarded && (
          <div
            className="forwarded-msg comms-font-size-small"
            style={chatStyles.fontRegular10SecondaryItalic}
          >
            {/* <ChatSVGS.Forward
              height={16}
              width={16}
              color={theme.text.secondary}
            /> */}
            Forwarded
          </div>
        )}
        {(repliedForMessage || repliedForMessageData) && (
          <ReplyView
            envelope={repliedForMessage}
            replyData={repliedForMessage}
            key={key}
            scrollToItem={scrollToItem}
          />
        )}
        <MessageLabel text={label} />
        {variant === 'sender' && (
          <span className="whatsapp-chat-item-name tertiary-font-semibold">
            {userName}
          </span>
        )}
        {renderedComponents}
        {intent?.endsWith('agent') ||
          (intent === 'unknown' && variant === 'sender' && (
            <>
              <span className="whatsapp-chat-item-extra tertiary-font-regular">
                -----------------------------------
              </span>
              <span className="whatsapp-chat-item-extra tertiary-font-regular">
                Rate AI Agent Response
              </span>
            </>
          ))}
        {intent === MessageType?.TRIAL &&
          (reply?.text === '👍' || reply?.text === '👎') && (
            <div className="sample-questions-container">
              {reply?.text === '👍'
                ? buttons[0]?.menuItems?.slice(0, 3)?.map((item, index) => (
                    <div
                      key={index}
                      className="sample-questions-container-item"
                      onClick={() => sendSampleQuestion(item?.description)}
                    >
                      <span className="sample-question-text">
                        {item?.description}
                      </span>
                      <img
                        src={JTBD_SVGS.SendOutlinedIcon}
                        alt=""
                        width={20}
                        height={20}
                        className="sample-question-icon"
                      />
                    </div>
                  ))
                : reply?.text === '👎' && (
                    <>
                      <div
                        className="sample-questions-container-item"
                        onClick={() =>
                          navigate(SIGNUP_ONBOARDING.RETRAIN_AGENT.path)
                        }
                      >
                        <img
                          src={JTBD_SVGS.UploadColorIcon}
                          alt=""
                          width={20}
                          height={20}
                          className="sample-question-icon"
                        />
                        <span className="sample-question-text">
                          Retrain the AI Agent
                        </span>
                      </div>
                      <div
                        className="sample-questions-container-item"
                        onClick={() => sendSampleQuestion('')}
                      >
                        <img
                          src={JTBD_SVGS.QuestionBlueIcon}
                          alt=""
                          width={20}
                          height={20}
                          className="sample-question-icon"
                        />
                        <span className="sample-question-text">
                          Try a different question
                        </span>
                      </div>
                    </>
                  )}
            </div>
          )}
        <span className="whatsapp-chat-item-time tertiary-font-regular">
          {msgTime}
        </span>
        <div className="button-container">
          {buttons?.map(
            (
              { text, color, isLoading = false, navigateTo, type, menuItems },
              index
            ) => {
              let isDisabled = !(
                type === TemplateButtonTypeEnum.QUICK_REPLY ||
                type === TemplateButtonTypeEnum.URL ||
                type === TemplateButtonTypeEnum.INTERACTIVE
              );
              if (
                intent === MessageType.TRIAL &&
                type === TemplateButtonTypeEnum.INTERACTIVE
              )
                return null;
              return (
                <Button
                  variant="text"
                  key={index}
                  style={{
                    color: isDisabled ? theme.text.secondary : color,
                  }}
                  onClick={() => {
                    if (navigateTo) {
                      // window.open(navigateTo, '_target');
                      changeToZonoMoneySimulator?.(navigateTo);
                    }
                    if (type === TemplateButtonTypeEnum.QUICK_REPLY) {
                      if (text === 'Know More' && isTourActive) {
                        dispatch(updateActiveTourTooltipIndex(12));
                      }
                      publishQuickReply(msgId, text);
                      isDisabled = true;
                    } else if (type === TemplateButtonTypeEnum.URL) {
                      if (text === 'Order Now' && isTourActive) {
                        dispatch(updateActiveTourTooltipIndex(13));
                      }
                    } else if (
                      type === TemplateButtonTypeEnum.INTERACTIVE &&
                      menuItems
                    ) {
                      onMenuClick(menuItems, msgId);
                    }
                  }}
                  className={`template-button comms-font-size-regular tertiary-font-semibold ${
                    isDisabled ? 'disabled' : ''
                  } ${text?.toLowerCase().replace(/\s+/g, '-')}`}
                  disabled={isDisabled}
                  startIcon={
                    type === TemplateButtonTypeEnum.QUICK_REPLY ? (
                      <ReplyIcon fontSize="small" />
                    ) : type === TemplateButtonTypeEnum.URL ? (
                      <LaunchIcon fontSize="small" />
                    ) : type === TemplateButtonTypeEnum.INTERACTIVE ? (
                      <ListIcon fontSize="small" />
                    ) : null
                  }
                >
                  {isLoading ? 'Please Wait...' : text}
                </Button>
              );
            }
          )}
        </div>
      </div>
      {variant === 'sender' && showFeedbackButtons && (
        <div className="whatsapp-chat-item-feedback tertiary-font-medium">
          <div
            className="feedback-button"
            style={
              feedback === '👎'
                ? { display: 'none' }
                : feedback === '👍'
                  ? { backgroundColor: '#2ABB7F', color: '#ffffff' }
                  : {}
            }
            onClick={() => {
              if (!feedback) {
                finService.trackEvent(
                  TrackEventType.SIGNUP_SIMULATOR_GOOD_FEEDBACK
                );
                publishReaction(msgId, '👍', reply?.text || '');
              }
            }}
          >
            <span
              className="feedback-button-emoji"
              role="img"
              aria-label="thumbs-up"
            >
              👍
            </span>
            <span className="feedback-button-text">Good</span>
          </div>
          <div
            className="feedback-button"
            style={
              feedback === '👍'
                ? { display: 'none' }
                : feedback === '👎'
                  ? { backgroundColor: '#E35A38', color: '#ffffff' }
                  : {}
            }
            onClick={() => {
              if (!feedback) {
                finService.trackEvent(
                  TrackEventType.SIGNUP_SIMULATOR_POOR_FEEDBACK
                );
                publishReaction(msgId, '👎', reply?.text || '');
              }
            }}
          >
            <span
              className="feedback-button-emoji thumbs-down"
              role="img"
              aria-label="thumbs-down"
            >
              👎
            </span>
            <span className="feedback-button-text">Poor</span>
          </div>
        </div>
      )}
    </div>
  );
};
